export default "__VITE_ASSET__MZJgVEzW__"